// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p2jYUWaIhWUAsbqJ {
	font: var(--lok-typography-body-action-small);
	font-family: var(--lok-font-family-inter);
	color: var(--lok-color-text-light-default);

	& a {
		text-decoration: underline;
		color: var(--lok-color-text-light-default);
	}

	& a:hover {
		color: var(--lok-color-text-default);
	}
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/Cards/ProfileCardStatic/ProfileCardStatic.module.css"],"names":[],"mappings":"AAAA;CACC,6CAA6C;CAC7C,yCAAyC;CACzC,0CAA0C;;CAE1C;EACC,0BAA0B;EAC1B,0CAA0C;CAC3C;;CAEA;EACC,oCAAoC;CACrC;AACD","sourcesContent":[".bodyText {\n\tfont: var(--lok-typography-body-action-small);\n\tfont-family: var(--lok-font-family-inter);\n\tcolor: var(--lok-color-text-light-default);\n\n\t& a {\n\t\ttext-decoration: underline;\n\t\tcolor: var(--lok-color-text-light-default);\n\t}\n\n\t& a:hover {\n\t\tcolor: var(--lok-color-text-default);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bodyText": `p2jYUWaIhWUAsbqJ`
};
export default ___CSS_LOADER_EXPORT___;
